(function($) {
	var $stickyCTA = $('.sticky-cta');

	if ($stickyCTA.length) {

		var $ctaInner = $stickyCTA.find('.sticky-cta-inner');
		var $headerLine = $('.header-line');
		var header_height = $('#masthead').outerHeight();

		if($(document).width()<992) header_height = $('#mobile-masthead').outerHeight();

		console.log(header_height);

		var cta_position = $stickyCTA.offset().top - header_height;

		$(window).scroll(function(){
			//if($(window).width() > 576 ) {

				if($(window).scrollTop() > cta_position) {
					$stickyCTA.addClass('fixed');

					if($headerLine.length){
						let headerLineHeight = $headerLine.height();
						if(headerLineHeight){
							$ctaInner.css({transform: `translateY(${headerLineHeight}px)`});
						}
					}

				} else {
					$stickyCTA.removeClass('fixed');
					if($headerLine.length){
						$ctaInner.css({transform:''});
					}

				}
			//}
			
		});

	}

	$('.sticky-cta-btn a').click(function(e) {
		e.preventDefault();
		$('.menu-popup-bg').fadeIn(300);
		$('.menu-popup').fadeIn(300);
	});

	$('.menu-popup-options a').click(function(e) {
		e.preventDefault();
		var src = $(this).attr('href');
		var top = $(document).scrollTop()+50;
		var city = $(this).attr('data-mobile-slider');
		if($(document).width()>767) {
			$("body").append('<div id="pricelist-wrapper" style="top: '+top+'px;"><div id="pricelist-img"><div id="pricelist-close">&times;</div><img src="'+src+'" alt=""/></div></div>'); 
		} else {
			if($('#'+city).find('.pricelist-slider').length) {
				$('#'+city).fadeIn(300).addClass('active');
				$('#'+city).css('top',top);
				$('.pricelist-mobile-wrapper.active .pricelist-slider').slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					dots: true
				});
			}
		}
	});

	$(document).on('click', function (event) {
		if ($(event.target).closest(".menu-popup").length) {return;}
		if ($(event.target).closest(".sticky-cta-btn a").length) {return;}
		if ($(event.target).closest("#pricelist-img").length) {return;}
		if ($(event.target).closest(".pricelist-mobile-wrapper").length) {return;}
		event.stopPropagation();
		$('.menu-popup-bg').fadeOut(300);
		$('.menu-popup').fadeOut(300);
		$('#pricelist-wrapper').remove();
		$('.pricelist-mobile-wrapper.active .pricelist-slider').slick('unslick');
		$('.pricelist-mobile-wrapper').fadeOut(300).removeClass('active');
	});

	$(document).on('click', '#pricelist-close', function () {
		$('#pricelist-wrapper').remove();
	});

	$(document).on('click', '.pricelist-close', function () {
		$('.pricelist-mobile-wrapper.active .pricelist-slider').slick('unslick');
		$(this).closest(".pricelist-mobile-wrapper").fadeOut(300).removeClass('active');
	});

	$(document).on('click', '.menu-popup-close', function () {
		$('.menu-popup-bg').fadeOut(300);
		$('.menu-popup').fadeOut(300);
		if($("#pricelist-wrapper").length)$('#pricelist-wrapper').remove();
		$('.pricelist-mobile-wrapper.active .pricelist-slider').slick('unslick');
		$('.pricelist-mobile-wrapper').fadeOut(300).removeClass('active');
	});


})(jQuery);